var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"wsRoundedHalf pa-6 mt-6"},[_vm._v(" Archived orders ")])}
var staticRenderFns = []

export { render, staticRenderFns }